import React, { useState, useEffect } from "react";
import { TextField } from "@mui/material";
import { updateListContact } from "store/reducers/list";

const EditableCell = ({ value, row, columnId, listId }) => {
  const [editing, setEditing] = useState(false);
  const [newValue, setNewValue] = useState(value);

  const handleClick = () => {
    setEditing(true);
  };

  const handleChange = (e) => {
    setNewValue(e.target.value);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      setEditing(false);
      updateFirestore();
    }
  };

  const handleBlur = () => {
    setEditing(false);
    updateFirestore();
  };

  const updateFirestore = async () => {
    if (newValue === value) return;
    try {
      const updatedContact = { ...row.original, [columnId]: newValue };
      await updateListContact(listId, updatedContact);
      console.log(`${columnId} updated successfully.`);
    } catch (error) {
      console.error(`Error updating ${columnId}:`, error);
    }
  };

  useEffect(() => {
    if (!editing) {
      setNewValue(value);
    }
  }, [editing, value]);

  return (
    <div onClick={handleClick} style={{ cursor: "pointer" }}>
      {editing ? (
        <TextField
          autoFocus
          value={newValue}
          onChange={handleChange}
          onKeyPress={handleKeyPress}
          onBlur={handleBlur}
          size="small"
        />
      ) : (
        value || "-"
      )}
    </div>
  );
};

export default EditableCell;
